import { type IResourceApiContext } from '../common'
import { Broker$CurrentUserApi } from './current-user'
import { ExperienceResourceApi } from '../client'

export class Broker$ExperienceResourceApi extends ExperienceResourceApi {
  currentUser: Broker$CurrentUserApi
  #ctx: IResourceApiContext

  constructor (ctx: IResourceApiContext) {
    super(ctx)
    this.#ctx = ctx
    this.currentUser = new Broker$CurrentUserApi(this.#ctx)
  }
}
